import { getRfqReasons } from '../api/api';

/**
 * Automatically fetch RFQ reasons for a quote
 * @param {string} quoteId - The quote ID to fetch reasons for
 * @param {Function} onSuccess - Callback when fetch succeeds, receives items_with_rfq array
 * @param {Function} onError - Callback when fetch fails, receives error object
 */
export const fetchRfqReasonsAuto = async (quoteId, onSuccess, onError) => {
  if (!quoteId) {
    console.warn('fetchRfqReasonsAuto: No quoteId provided');
    onError?.(new Error('Quote ID is required'));
    return;
  }

  try {
    const response = await getRfqReasons(quoteId);
    if (response.status === "success") {
      onSuccess?.(response.data.items_with_rfq);
    } else {
      const error = new Error(response.message || "Failed to fetch RFQ reasons");
      onError?.(error);
    }
  } catch (error) {
    console.error("Error fetching RFQ reasons:", error);
    onError?.(error);
  }
};
